import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

export interface ListRowProps {
  title: ReactNode;
  subtitle?: ReactNode;
  leading?: ReactNode;
  trailing?: ReactNode;
  /** Кликабельная строка: стрелка справа и активное состояние */
  onClick?: () => void;
  disabled?: boolean;
  /**
   * Переносить заголовок и подпись вместо обрезки — там, где важен весь текст: вариант опроса с
   * датой, подсказка «отправь /bind», название документа на 320 px (раунд 3, C5/C6).
   */
  wrap?: boolean;
  className?: string;
}

function Chevron() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

/** Строка списка: иконка/аватар слева, заголовок и подпись, значение или стрелка справа. */
export function ListRow({
  title,
  subtitle,
  leading,
  trailing,
  onClick,
  disabled,
  wrap,
  className,
}: ListRowProps) {
  const line = wrap ? 'break-words' : 'truncate';
  const content = (
    <>
      {leading ? <div className="shrink-0">{leading}</div> : null}
      <div className="min-w-0 flex-1">
        <div className={cn(line, 'text-base font-medium')}>{title}</div>
        {subtitle ? <div className={cn(line, 'text-muted text-sm')}>{subtitle}</div> : null}
      </div>
      {trailing ? <div className="text-muted shrink-0 text-sm">{trailing}</div> : null}
      {onClick ? <Chevron /> : null}
    </>
  );

  const base = cn(
    'flex w-full items-center gap-3 px-4 py-3 text-left',
    'border-border border-b last:border-b-0',
    className,
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={cn(base, 'text-fg pressable active:bg-surface-2 disabled:opacity-50')}
      >
        {content}
      </button>
    );
  }
  return <div className={base}>{content}</div>;
}
